import React from 'react';
import { Grid } from 'semantic-ui-react';

import GridColumnInputWrapper from '../../../../common/GridColumnInputWrapper';
import { AccordionWrapper, InputWrapper } from 'react-lib/dist/components-es';
import ExternalDocumentTagsUrlInputWrapper from '../../../../common/ExternalDocumentTagsUrlInputWrapper';
import { setRowSize } from 'utils';

type Props = {
  values: any;
  disabled: boolean;
  setFieldValue: (arg1: string, arg2: string) => void;
  errors: any;
};

const IExposureMonitoringContainer = ({ values, disabled, setFieldValue, errors }: Props) => {
  const getContainerContent = () => {
    const inputText = values.chemicalRiskAttributes.exposureMonitoringDesc || '';
    const rows = setRowSize(inputText, 3, 40);

    return (
      <Grid stackable columns={2} verticalAlign="top">
        <GridColumnInputWrapper
          width={12}
          rows={rows}
          value={inputText}
          name="chemicalRiskAttributes.exposureMonitoringDesc"
          label="inventory.details.page.prevention.protection.container.exposure.monitoring.desc"
          type="textarea"
          disabled={disabled}
          values={values}
          setFieldValue={setFieldValue}
          errors={errors}
          render={(props: any) => <InputWrapper {...props} />}
        />
        <GridColumnInputWrapper
          width={4}
          name="chemicalRiskAttributes.edmsNumbersExposureMonitoring"
          label="inventory.details.page.exposure.monitoring.container.edms.numbers.input"
          disabled={disabled}
          values={values}
          setFieldValue={setFieldValue}
          errors={errors}
          render={(props: any) => (
            <ExternalDocumentTagsUrlInputWrapper
              {...props}
              matchProperty="edmsNumber"
              displayProps="edmsNumber"
              value={values.chemicalRiskAttributes.edmsNumbersExposureMonitoring}
              onlyUnique={true}
              onlyAutocomplete={false}
            />
          )}
        />
      </Grid>
    );
  };

  return (
    <AccordionWrapper
      accordionTitle="inventory.details.page.prevention.protection.measures.exposure.monitoring.container.title"
      className="containerReducedWhiteSpace"
      render={getContainerContent}
    />
  );
};

export default IExposureMonitoringContainer;
